import { render } from "./TokenBlock.vue?vue&type=template&id=3dc30d5f&bindings={\"token\":\"props\",\"backgroundColor\":\"props\"}"
import script from "./TokenBlock.vue?vue&type=script&lang=js"
export * from "./TokenBlock.vue?vue&type=script&lang=js"

import "./TokenBlock.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
